export default __webpack_public_path__ + "static/media/section-1-artwork-sample.1c5bee8e.png";